import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CityService} from '@services/city.service';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-city-square-price',
    templateUrl: './city-square-price.component.html',
    styleUrls: ['./city-square-price.component.scss']
})
export class CitySquarePriceComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();

    constructor(public cityService: CityService) {
    }

    ngOnInit() {

    }
}
